<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QdlSCf/tc-custom/9781452139036.jpg?1701327922549" alt="This image is the cover for the book Best Lunch Box Ever"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Best Lunch Box Ever
      </h1>
      <p class="bookDescription body article font2">
        <b>“Does a truly sweet job of helping parents pack more inspired lunches . . . recipes for everything from wraps and sandwiches to pizzas and salads.” —<i>Publishers Weekly</i></b><br/><br/><i>Best Lunch Box Ever</i> is full of recipes, ideas, and strategies for packing creative and healthful lunches for kids, solving what is for many parents the most taxing of daily chores. Kids will love the scrumptiousness, while busy moms and dads will appreciate the quick and simple solutions for wholesome, balanced meals developed by Katie Sullivan Morford, a registered dietician and mother of three. The sixty-five recipes are easy, delicious, and—best of all—packed with nutrients for well-rounded lunches and snacks, including Deconstructed Caprese Skewers, Easy Cheesy Thermos Beans, Pesto Pita Pizza, Cinnamon Wonton Crisps, Parmesan Kale Chips, Crispy Applewiches, and more.<br/><br/><b>“Katie Morford has dozens of interesting and sometimes surprising suggestions for easy, delicious, and nutritious lunch items that kids will enjoy—if parents don’t get to them first.” —Marion Nestle, James Beard Award–winning author of <i>Unsavory Truth</i></b><br/><br/><b>“This wonderful book is sure to get you out of a lunch-box rut, with inspiring, easy, healthful ideas for lunches that will put a smile on any kid’s face!” —Ellie Krieger, host of Food Network’s <i>Healthy Appetite</i></b><br/><br/><b>“Ideal for parents and professionals, this cookbook features winning lunch ideas for eco- and health-conscious households.” —<i>Library Journal</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katie Sullivan Morford, Jennifer Martiné
      </h2>
      
      <p class="authorDescription body article">Katie Sullivan Morford is a registered dietician, a freelance food and nutrition writer, and founder of the Mom's Kitchen Handbook blog. She lives in San Francisco, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24eb7e02